<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'

// Define props
const props = defineProps({
    shopName: {
        type: String,
        default: '',
        validator(rawValue) {
            return rawValue === undefined || typeof rawValue === 'string'
        }
    }
})

// Fetch route
const route = useRoute()
const centerRoute = computed(() => route.params?.centerUid)
const shopUid = computed(() => route.params?.shopUid)

// Initial fetch (consumer) coupons
const bearerToken = useState('state_bearerToken')
const oid = useState('state_userOid')

const { data: couponsData, suspense: couponSuspense, isPlaceholderData: isCouponsPlaceholder } = useFetchCoupons({
    centerRoute: centerRoute.value,
    shopUid: shopUid.value,
    bearerToken,
    oid
})

onServerPrefetch(async () => {
    await couponSuspense()
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

const couponListConfig = computed(() => {
    return {
        placeholder: isCouponsPlaceholder.value,
        items: couponsData.value,
        couponLink: 'centerUid-shops-shopUid-coupons',
        shopName: props.shopName,
        tracking: 'shopDetail'
    }
})

const couponListHeadlineConfig = computed(() => {
    return {
        title: staticKeys.value?.shops_details_goodies_headline_web_markdown,
        renderSplit: true
    }
})
</script>

<template>
    <section class="shop-coupons-wrapper">
        <ContentHeadline :content-headline-config="couponListHeadlineConfig" />
        <CouponList :coupon-list-config="couponListConfig" />
    </section>
</template>

<style lang="scss">
.shop-coupons-wrapper {
    margin: 0 auto 20px;

    @include bp(medium1) {
        margin: 0 auto 40px;
    }

    @include bp(large2) {
        margin: 0 auto 60px;
    }
}
</style>
